"use client";

import styled from "styled-components";

//Styled
import PhoneInput from "react-phone-input-2";

export const BoxPhoneInput = styled.div`
  width: 100%;
  max-width: initial !important;
  background: transparent !important;
`;

export const InputPhone = styled(PhoneInput)`
  border: 1px solid var(--borderColor);
  border-radius: 7px;
  font-family: "Roboto Light";
  font-size: 14px;
  color: var(--titleColor);

  .flag-dropdown {
    background: transparent;
    border: none;

    .selected-flag {
      border-radius: 7px 0 0 7px !important;
      background: transparent;
      &:hover {
        background: transparent;
      }

      &.open {
        background: transparent;
      }
    }

    &.open {
      background: transparent;
    }
  }

  .country-list {
    background-color: var(--backgroundColorCard) !important;
    border-radius: 15px;

    &::-webkit-scrollbar-track {
      background: var(--transparent);
    }

    &::-webkit-scrollbar {
      width: 3px;
      background: var(--transparent);
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: var(--transparent);
    }

    .search {
      background-color: var(--backgroundColorCard) !important;
      input {
        padding-left: 0 !important;
      }
    }

    .country {
      &:hover,
      &.highlight {
        background: var(--lightGray) !important;
      }
    }
  }

  input {
    padding-left: 45px !important;
    background: transparent !important;
    border: none !important;
  }
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  display: block;
  color: var(--red);
`;
